// extracted by mini-css-extract-plugin
export default {"container":"TotalInfo_container__8zM5u"};